<template>
  <b-modal
    title="RESIDENTES"
    id="bonded_residents"
    no-close-on-backdrop
    hide-footer
  >
    <b-row>
      <b-col>
        <h4>RESIDENTES VINCULADOS COM O TIPO DE HOSPEDAGEM</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <v-data-table dense :items="residents" :headers="headers">
        </v-data-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <v-btn class="btn-return" @click="$bvModal.hide('bonded_residents')">
          <i class="fas fa-arrow-left mr-2 text-twenty"></i> VOLTAR
        </v-btn>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: "BondedResidents",

  props: {
    residents: Array,
  },

  data() {
    return {
      headers: [{ text: "Nome", value: "name" }],
    };
  },
};
</script>

<style>
</style>